export const shouldShowILPAsIcon = ({ windowWidth, hasMoreThanOneButton }) => {
  if (windowWidth < 1280 || hasMoreThanOneButton) {
    return true
  }
  return false
}
